const sanctumTokenKey = 'scape.sanctum_token';

export const getSanctumToken = () => {
  const token = window.localStorage.getItem(sanctumTokenKey);
  return token ?? null;
};

export const setSanctumToken = (token: string) => {
  window.localStorage.setItem(sanctumTokenKey, token);
};

export const removeSanctumToken = () => {
  window.localStorage.removeItem(sanctumTokenKey);
};

export const getSanctumBearerToken = () => {
  const token = getSanctumToken();
  return token ? `Bearer ${token}` : null;
};
